// components/layouts/OnboardingLayout.tsx
import { ReactNode } from 'react';
import clsx from 'clsx';
import { LoadingSpinner } from '@/components/common/LoadingSpinners';
import { OnboardingEnum } from '@/types/translations/OnboardingEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import OnBoardingInformation from './OnBoardingInformation';
import { OnBoardingInformationItem } from '@/types/props/components/onboarding';

type OnboardingLayoutProps = {
  header: ReactNode;
  loading: boolean;
  meta: ReactNode;
  content: ReactNode;
  items: OnBoardingInformationItem[];
};

export const OnboardingLayout = ({
  header,
  loading,
  meta,
  content,
  items,
}: OnboardingLayoutProps) => {
  const { translate } = useTypedTranslation<OnboardingEnum>('onboarding');
  return (
    <>
      {meta}
      <div className="tw-flex tw-min-h-screen tw-overflow-hidden child:tw-flex-grow max-nine:!tw-mx-0 max-nine:tw-flex-col max-nine:!tw-px-0 nine:tw-items-stretch">
        <div className="tw-w-8/12 max-nine:tw-w-full max-nine:tw-px-3 max-nine:tw-pb-24">
          <div className="tw-flex tw-flex-col tw-pb-12 max-nine:tw-pt-24">
            <div className="tw-w-full max-nine:tw-fixed max-nine:tw-left-0 max-nine:tw-top-0 max-nine:tw-z-50 max-nine:tw-flex max-nine:tw-flex-col max-nine:tw-bg-white max-nine:tw-px-4">
              {header}
            </div>
            <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-pt-12 max-nine:tw-h-full max-nine:tw-flex-grow max-sm:tw-px-1 sm:tw-px-4 nine:tw-pt-2">
              <div
                className={clsx('tw-w-full tw-py-12 xl:tw-px-20', {
                  ['tw-hidden']: !loading,
                })}
              >
                <LoadingSpinner
                  loadingSubtitle={translate(OnboardingEnum['common.we_re_loading_your_data'])}
                  loadingTitle={translate(OnboardingEnum['common.please_wait'])}
                  show={true}
                />
              </div>
              <div
                className={clsx(
                  'tw-w-full tw-py-12 tw-pb-24 max-nine:tw-h-full max-nine:tw-flex-grow max-nine:tw-flex-col max-nine:tw-pr-0 xl:tw-px-20',
                  {
                    ['tw-hidden']: loading,
                    ['max-nine:tw-flex']: loading === false,
                  }
                )}
              >
                {content}
              </div>
            </div>
          </div>
        </div>
        <div className="tw-flex-grow tw-overflow-y-auto child:tw-h-full child:tw-w-full max-nine:tw-h-fit max-nine:tw-w-full nine:tw-min-h-screen nine:tw-w-4/12">
          <OnBoardingInformation items={items} />
        </div>
      </div>
    </>
  );
};
